import { render, staticRenderFns } from "./stratlist.vue?vue&type=template&id=47eff78b&scoped=true&"
import script from "./stratlist.vue?vue&type=script&lang=js&"
export * from "./stratlist.vue?vue&type=script&lang=js&"
import style0 from "./stratlist.vue?vue&type=style&index=0&id=47eff78b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eff78b",
  null
  
)

export default component.exports